import { render, staticRenderFns } from "./DocEmissao.vue?vue&type=template&id=da4dcb28&scoped=true&lang=pug&"
import script from "./DocEmissao.vue?vue&type=script&lang=js&"
export * from "./DocEmissao.vue?vue&type=script&lang=js&"
import style0 from "./DocEmissao.vue?vue&type=style&index=0&id=da4dcb28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4dcb28",
  null
  
)

export default component.exports